const holidays = {
  headerButtons: {
    create: 'Create',
    delete: 'Delete',
  },

  table: {
    headers: {
      start: 'Start',
      end: 'End',
    },
    actions: {
      delete: 'Delete',
      export: 'Export',
    },
  },

  create: {
    successToast: {
      body: 'Holiday Has Been Added Successfully',
    },
    errorModal: {
      header: 'Error Occurred',
      body: 'Could Not Create Holiday',
    },
  },
  delete: {
    successToast: {
      body: 'Holidays Has Been Deleted Successfully',
    },
    errorToast: {
      body: 'Could Not Create Holiday',
    },
  },
  edit: {
    errorToast: {
      body: 'Could Not Create Holiday',
    },
    successToast: {
      body: 'Holiday Has Been Updated Successfully',
    },
    errorModal: {
      header: 'Error Occurred',
      body: 'Could Not Update Holiday',
    },
    successModal: {
      header: 'Success',
      body: 'Holiday Updated!',
    },
  },

  forms: {
    header: {
      create: {
        title: 'Create',
      },

      update: {
        title: 'Update',
      },
    },

    details: {
      header: 'Details',
      fields: {
        name: 'Name',
      },
    },
    dates: {
      header: 'Range of Dates',
      fields: {
        rangeSwitch: 'Range of Dates',
        start: 'Start',
        end: 'End',
        date: 'Date',
      },
    },
    footer: {
      confirmButtonText: {
        create: 'Submit',
        update: 'Submit',
      },
    },
  },
};

export default holidays;
